import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-resort-dashboard',
  templateUrl: './resort-dashboard.component.html',
  styleUrls: ['./resort-dashboard.component.scss']
})
export class ResortDashboardComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
